<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    max-width="750"
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-card
      rounded="xl"
      elevation="8"
      class="d-flex flex-column"
      style="max-height: 85vh"
    >
      <v-btn
        icon
        variant="text"
        size="small"
        class="faq-close-btn"
        @click="closePopup"
        id="home-faq-close-btn"
      >
        <v-icon size="22">mdi-close</v-icon>
      </v-btn>

      <div class="px-4 px-sm-8 pt-10 pb-2 flex-grow-0 flex-shrink-0">
        <template v-if="activeArticle">
          <v-btn
            variant="text"
            size="small"
            class="px-0 text-text-subdued mb-4 font-weight-medium text-uppercase"
            style="margin-top: -15px; letter-spacing: 0.5px"
            prepend-icon="mdi-arrow-left"
            @click="$emit('clearArticle')"
            id="home-faq-back-to-subtopic-btn"
          >
            {{
              activeTopic
                ? isIndonesia()
                  ? activeTopic?.topic
                  : activeTopic?.topic_en || activeTopic?.topic
                : isIndonesia()
                ? "Kembali ke Hasil"
                : "Back to Results"
            }}
          </v-btn>

          <v-row align="start" justify="space-between" class="mb-4" no-gutters>
            <v-col cols="12" sm class="pr-0 pr-sm-4 mb-3 mb-sm-0">
              <div
                class="text-medium-emphasis mb-2 font-weight-bold"
                style="color: #666"
              >
                {{
                  isIndonesia()
                    ? "Jawaban yang Anda cari:"
                    : "The answer to your needs:"
                }}
              </div>
              <div class="faq-article-title">
                "{{
                  isIndonesia()
                    ? activeArticle.articletitle
                    : activeArticle.articletitle_en ||
                      activeArticle.articletitle
                }}"
              </div>
            </v-col>

            <v-col cols="12" sm="auto" class="pr-sm-8">
              <v-text-field
                :model-value="search"
                @update:model-value="$emit('update:search', $event)"
                @keydown.enter.prevent="handleSearch"
                :placeholder="
                  isIndonesia() ? 'Tanyakan apa saja...' : 'Ask me anything...'
                "
                density="compact"
                variant="outlined"
                hide-details
                style="min-width: 250px"
                id="home-faq-search-detail-input"
              >
                <template #append-inner>
                  <v-icon
                    size="small"
                    class="cursor-pointer"
                    @click="handleSearch"
                    >mdi-send</v-icon
                  >
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </template>

        <template v-else-if="activeTopic || localSearchSubmitted">
          <v-row
            justify="space-between"
            class="align-sm-center mb-4 mt-2"
            no-gutters
          >
            <v-col
              cols="12"
              sm
              class="d-flex align-center flex-wrap mb-3 mb-sm-0"
            >
              <v-btn
                variant="text"
                size="small"
                class="px-0 text-text-subdued font-weight-medium text-uppercase"
                style="letter-spacing: 0.5px"
                prepend-icon="mdi-arrow-left"
                @click="handleBackToHome"
                id="home-faq-back-btn"
              >
                {{ isIndonesia() ? "Kembali ke Beranda" : "Back to Home" }}
              </v-btn>

              <template v-if="activeTopic">
                <span
                  class="mx-3"
                  style="color: #e0e0e0; font-size: 1.2rem; font-weight: 300"
                  >|</span
                >
                <span
                  class="text-h5 font-weight-bold"
                  style="color: #333; line-height: 1"
                >
                  {{
                    isIndonesia()
                      ? activeTopic.topic
                      : activeTopic.topic_en || activeTopic.topic
                  }}
                </span>
              </template>
            </v-col>

            <v-col cols="12" sm="auto" class="pr-sm-8">
              <v-text-field
                :model-value="search"
                @update:model-value="$emit('update:search', $event)"
                @keydown.enter.prevent="handleSearch"
                :placeholder="
                  isIndonesia() ? 'Tanyakan apa saja...' : 'Ask me anything...'
                "
                density="compact"
                variant="outlined"
                hide-details
                style="min-width: 250px"
              >
                <template #append-inner>
                  <v-icon
                    size="small"
                    class="cursor-pointer"
                    @click="handleSearch"
                    >mdi-send</v-icon
                  >
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </template>

        <template v-else>
          <div class="faq-title mb-5 mt-2" style="padding-right: 32px">
            <template v-if="isIndonesia()">
              Akses informasi lebih mudah.<br />Dapatkan jawaban lebih cepat.
            </template>
            <template v-else>
              Information made simple.<br />Find information instantly.
            </template>
          </div>

          <v-textarea
            :model-value="search"
            @update:model-value="$emit('update:search', $event)"
            @keydown.enter.prevent="handleSearch"
            :placeholder="
              isIndonesia() ? 'Cari bantuan di sini...' : 'Ask me anything...'
            "
            variant="outlined"
            density="comfortable"
            hide-details
            class="mb-2 bottom-icon"
            id="home-faq-search-input"
            rows="2"
            no-resize
          >
            <template #append-inner>
              <v-icon size="16" class="cursor-pointer" @click="handleSearch"
                >mdi-send</v-icon
              >
            </template>
          </v-textarea>
        </template>
      </div>

      <v-card-text
        class="px-4 px-sm-8 py-2 overflow-y-auto"
        style="overflow-y: auto"
      >
        <template v-if="activeArticle">
          <div
            class="text-text-default faq-article-body mb-8"
            style="font-size: 0.875rem"
            v-html="
              isIndonesia()
                ? activeArticle.description
                : activeArticle.description_en || activeArticle.description
            "
          />
        </template>

        <template v-else-if="activeTopic || localSearchSubmitted">
          <div v-if="loading" class="d-flex justify-center py-8">
            <v-progress-circular indeterminate color="primary" />
          </div>

          <template v-else>
            <v-row v-if="!activeTopic && localSearchSubmitted" class="mb-8">
              <v-col
                v-for="(group, topicName) in groupedSearchResults"
                :key="topicName"
                cols="12"
                sm="6"
                md="4"
              >
                <div
                  class="font-weight-bold mb-3 d-flex align-center"
                  style="color: #333; font-size: 0.9rem"
                >
                  {{ topicName }}
                  <v-icon size="x-small" color="success" class="ml-2"
                    >mdi-file-document-outline</v-icon
                  >
                </div>

                <div
                  v-for="item in expandedTopics.includes(topicName)
                    ? group.items
                    : group.items.slice(0, 3)"
                  :key="item.subtopic"
                  class="text-body-2 mb-2 faq-subtopic-hover"
                  @click="$emit('openArticle', item)"
                  style="font-size: 0.85rem !important"
                >
                  {{
                    isIndonesia()
                      ? item.subtopic
                      : item.subtopic_en || item.subtopic
                  }}
                </div>

                <div
                  v-if="group.items.length > 3"
                  class="text-caption mt-2 font-weight-medium"
                  style="color: #30a882; cursor: pointer"
                  @click="toggleExpand(topicName)"
                >
                  {{
                    expandedTopics.includes(topicName)
                      ? isIndonesia()
                        ? "Lihat lebih sedikit"
                        : "See less"
                      : isIndonesia()
                      ? "Lihat lebih banyak"
                      : "See more"
                  }}
                </div>
              </v-col>
            </v-row>

            <v-row v-else-if="activeTopic" class="mb-8">
              <v-col cols="12">
                <div
                  v-for="(item, i) in faqDataForActiveTopic"
                  :key="i"
                  class="text-body-2 mb-3 faq-subtopic-hover pb-2"
                  style="border-bottom: 1px solid #f0f0f0"
                  @click="$emit('openArticle', item)"
                >
                  {{
                    isIndonesia()
                      ? item.subtopic
                      : item.subtopic_en || item.subtopic
                  }}
                </div>
              </v-col>
            </v-row>
          </template>
        </template>

        <template v-else>
          <div class="d-flex ga-3 align-center">
            <img
              src="@/assets/images/icons/search.png"
              width="26"
              height="26"
              alt="SPIL"
              style="flex-shrink: 0; margin-top: 2px"
            />

            <v-sheet color="#fff9e0" class="pa-3 mb-1 rounded-lg flex-grow-1">
              <div class="d-flex align-start ga-3">
                <div class="text-caption text-medium-emphasis font-weight-bold">
                  {{
                    isIndonesia()
                      ? "Temukan layanan SPIL, cek pengiriman, dan akses bantuan dengan cepat dalam satu menu."
                      : "Explore SPIL services, find shipment updates, and get instant logistics support in one place."
                  }}
                  <!-- <br /><em>{{
                    isIndonesia()
                      ? "Semakin detail informasi yang Anda bagikan, semakin baik kami dapat membantu Anda."
                      : "The more details you share, the better we can assist you."
                  }}</em> -->
                </div>
              </div>
            </v-sheet>
          </div>
        </template>

        <!-- Explore Topics (inside scrollable area, visible ONLY on mobile) -->
        <div class="pb-6 pt-4 d-block d-sm-none">
          <div class="font-weight-bold mt-2 mb-3" style="color: #a5a5a5">
            {{ isIndonesia() ? "Telusuri Topik" : "Explore Topics" }}
          </div>
          <v-row dense>
            <v-col v-for="(topic, idx) in faqTopic" :key="idx" cols="6">
              <span
                class="faq-topic-link"
                :id="`home-faq-topic-mobile-${idx}`"
                @click="handleSelectTopic(topic)"
              >
                {{
                  isIndonesia() ? topic.topic : topic.topic_en || topic.topic
                }}
              </span>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <!-- Explore Topics (fixed footer outside scrollable area, visible ONLY on desktop) -->
      <div class="px-8 pb-8 pt-2 flex-grow-0 flex-shrink-0 d-none d-sm-block">
        <div class="font-weight-bold mt-2 mb-3" style="color: #a5a5a5">
          {{ isIndonesia() ? "Telusuri Topik" : "Explore Topics" }}
        </div>
        <v-row dense>
          <v-col v-for="(topic, idx) in faqTopic" :key="idx" cols="4">
            <span
              class="faq-topic-link"
              :id="`home-faq-topic-${idx}`"
              @click="handleSelectTopic(topic)"
            >
              {{ isIndonesia() ? topic.topic : topic.topic_en || topic.topic }}
            </span>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapWritableState } from "pinia";
import { useGuideStore } from "@/stores/GuideStore";
import { isIndonesia } from "@/utils/language";

export default {
  name: "HomeFaqPopup",

  props: {
    modelValue: { type: Boolean, default: false },
    search: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    activeTopic: { type: Object, default: null },
    activeArticle: { type: Object, default: null },
  },

  emits: [
    "update:modelValue",
    "update:search",
    "close",
    "doSearch",
    "selectTopic",
    "clearTopic",
    "openArticle",
    "clearArticle",
  ],

  data() {
    return {
      localSearchSubmitted: false,
      expandedTopics: [],
    };
  },

  watch: {
    modelValue(isOpen) {
      if (!isOpen) {
        this.localSearchSubmitted = false;
        this.expandedTopics = [];
      }
    },
  },

  computed: {
    ...mapWritableState(useGuideStore, ["faqData", "faqTopic"]),

    faqDataForActiveTopic() {
      if (!this.activeTopic) return [];
      return this.faqData.filter((x) => x.topicid == this.activeTopic.topicid);
    },

    groupedSearchResults() {
      if (!this.faqData) return {};
      const grouped = {};

      this.faqData.forEach((item) => {
        const topicObj = this.faqTopic.find((t) => t.topicid === item.topicid);
        if (topicObj) {
          const topicName = this.isIndonesia()
            ? topicObj.topic
            : topicObj.topic_en || topicObj.topic;

          if (!grouped[topicName]) {
            grouped[topicName] = { topicObj, items: [] };
          }
          grouped[topicName].items.push(item);
        }
      });
      return grouped;
    },
  },

  methods: {
    isIndonesia() {
      return isIndonesia();
    },

    // Add this method to handle toggling the expanded state
    toggleExpand(topicName) {
      if (this.expandedTopics.includes(topicName)) {
        // If already expanded, remove it to collapse
        this.expandedTopics = this.expandedTopics.filter(
          (t) => t !== topicName,
        );
      } else {
        // Otherwise, add it to expand
        this.expandedTopics.push(topicName);
      }
    },

    handleSearch() {
      if (!this.search.trim()) return;
      this.localSearchSubmitted = true;
      this.expandedTopics = []; // Reset expansions on new search
      this.$emit("clearTopic");
      this.$emit("doSearch");
    },

    handleSelectTopic(topic) {
      this.localSearchSubmitted = false;
      this.expandedTopics = []; // Reset expansions
      this.$emit("update:search", "");
      this.$emit("selectTopic", topic);
    },

    handleBackToHome() {
      this.localSearchSubmitted = false;
      this.expandedTopics = []; // Reset expansions
      this.$emit("update:search", "");
      this.$emit("clearTopic");

      this.$nextTick(() => {
        this.$emit("doSearch");
      });
    },

    closePopup() {
      this.localSearchSubmitted = false;
      this.expandedTopics = []; // Reset expansions
      this.$emit("update:search", "");
      this.$emit("close");

      this.$nextTick(() => {
        this.$emit("doSearch");
      });
    },
  },
};
</script>

<style scoped>
/* Improved Close Button */
.faq-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
  color: #a5a5a5;
  transition: all 0.2s ease;
}
.faq-close-btn:hover {
  color: #333;
  background-color: #f0f0f0;
}

/* Title */
.faq-title {
  font-size: 1.3rem;
  line-height: 1.5;
  color: #444;
  font-weight: 500;
}

/* Topic links (grid) */
.faq-topic-link {
  display: block;
  font-size: 0.85rem;
  font-weight: 500;
  color: #1a3a4a;
  cursor: pointer;
  padding: 2px 0;
  line-height: 1.5;
  transition: color 0.15s;
}
.faq-topic-link:hover {
  color: #30a882;
  text-decoration: underline;
}

/* Sub-topic Item */
.faq-subtopic-hover {
  cursor: pointer;
  color: #555;
  transition: color 0.15s ease-in-out;
  line-height: 1.4;
}
.faq-subtopic-hover:hover {
  color: #30a882;
  text-decoration: underline;
}

/* Article title */
.faq-article-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #30a882;
  line-height: 1.4;
}

/* Article HTML body */
::v-deep .faq-article-body p {
  margin-bottom: 0.75rem;
}
::v-deep .faq-article-body ol,
::v-deep .faq-article-body ul {
  padding-left: 1.5rem;
  margin-bottom: 0.75rem;
}
::v-deep .faq-article-body li {
  margin: 4px 0;
}

/* Vuetify search field */
::v-deep .v-field--variant-outlined .v-field__outline {
  --v-field-border-opacity: 1;
}

.bottom-icon :deep(.v-field__append-inner) {
  align-items: flex-end !important;
  padding-bottom: 8px;
}

/* Mobile */
@media screen and (max-width: 599px) {
  .faq-title {
    font-size: 1.1rem;
  }
}
</style>
